import styled from '@emotion/styled';
import { FC } from 'react';

import { FontFamily } from '@/enums/index';
import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

const Wrapper = styled.div<{ isVisible: boolean } & IThemeProps>`
  position: absolute;
  padding: 40px 24px;
  background: white;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  transition: opacity 0.5s ease-in;
  min-height: 270px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    padding: 40px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    min-height: 350px;
    padding: 70px 72px;
  }
`;

const Message = styled.div<IThemeProps>`
  font-family: ${FontFamily.IBMPlexSans};
  font-style: italic;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.legacy.colors.black};

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    font-size: 20px;
    line-height: 135%;
  }
`;

const AuthorContainer = styled.div`
  display: flex;
`;

const AuthorImage = styled.img`
  width: 80px;
  height: 80px;
  margin-right: 20px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Name = styled.h3`
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
`;

const Affiliation = styled.span`
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
`;

interface ITestimonialCardProps {
  testimonial: { image: string; name: string; affiliation: string; text: string };
  visible: boolean;
}

export const TestimonialCard: FC<ITestimonialCardProps> = ({ testimonial, visible }) => {
  return (
    <Wrapper isVisible={visible}>
      <Message>
        <q>{testimonial.text}</q>
      </Message>
      <AuthorContainer>
        <AuthorImage src={testimonial.image} />
        <Title>
          <Name>{testimonial.name}</Name>
          <Affiliation>{testimonial.affiliation}</Affiliation>
        </Title>
      </AuthorContainer>
    </Wrapper>
  );
};
